module.exports = __webpack_public_path__ + "img/d1a0045.jpg";